var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalRef",
      attrs: {
        title: "Termos e Condições - Programa ecash",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "ok-title": _vm.$t("Aceitar"),
        "cancel-title": _vm.$t("Recusar"),
        "ok-disabled":
          _vm.loading || _vm.termsHtml === "Nenhum termo disponível",
        "dialog-class": "reward-terms-modal",
      },
      on: { ok: _vm.onAccept, cancel: _vm.onReject },
    },
    [
      _c("div", { staticClass: "terms-container" }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "text-center py-5" },
              [
                _c("b-spinner", {
                  attrs: {
                    label: "Carregando termos...",
                    type: "border",
                    variant: "primary",
                  },
                }),
              ],
              1
            )
          : _c("div", { staticClass: "terms-content" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.termsHtml) } }),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }